import { render, staticRenderFns } from "./edit-tags-modal.vue?vue&type=template&id=7ec61396&scoped=true&"
import script from "./edit-tags-modal.vue?vue&type=script&lang=js&"
export * from "./edit-tags-modal.vue?vue&type=script&lang=js&"
import style0 from "./edit-tags-modal.vue?vue&type=style&index=0&id=7ec61396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec61396",
  null
  
)

export default component.exports